module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Top', {
    attrs: {
      "title": "Материалы",
      "subtitle": "Учебные материалы для изучения."
    }
  }, [(_vm.isLoading) ? _c('LoadingSpinner', {
    attrs: {
      "size": 100
    }
  }) : [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Ошибка"
    }
  }) : [(_vm.data.length) ? _c('Info', {
    attrs: {
      "items": _vm.data
    }
  }) : _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("На данный момент заданий нет.")])])]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-656863c7","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/lessons/Lessons.vue
// module id = 6130fba371f801b82d17
// module chunks = 26